import {
  DataRefreshEvent,
  type OrganizationDepositInitiatedPayload,
} from "@fp/admin-api-client";
import { useDataRefresh } from "@/hooks/useSignalR";
import { formatCurrency } from "@/lib/format-currency";
import { toast } from "@/lib/toast";

const AUTO_TOP_UP_CONTEXT = "AutoTopUp";

export function DepositToasts() {
  useDataRefresh<OrganizationDepositInitiatedPayload>(DataRefreshEvent.OrganizationDepositInitiated, (payload) => {
    const subject = payload.context === AUTO_TOP_UP_CONTEXT ? "Auto top-up deposit" : "Deposit";
    toast.success(`${subject} of $${formatCurrency(payload.amount)} initiated`);
  });

  return null;
}
